import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers(
  'supportPortalConfig'
)

export const SupportPortalConfigComputed = {
  ...mapGetters({
    allowRegistration: 'allowRegistration',
    allowGuestToCreateIncident: 'allowGuestToCreateIncident',
    allowGuestToRequestForService: 'allowGuestToRequestForService',
    showRelatedKnowledge: 'showRelatedKnowledge',
    allowToLinkAsset: 'allowToLinkAsset',
    autoLinkRequesterAsset: 'autoLinkRequesterAsset',
    autoLinkRequesterCi: 'autoLinkRequesterCi',
    allowToLinkOthersAsset: 'allowToLinkOthersAsset',
    allowToLinkOthersCi: 'allowToLinkOthersCi',
    allowToLinkCi: 'allowToLinkCi',
    allowToReopenClosedReq: 'allowToReopenClosedReq',
    allowToCloseReq: 'allowToCloseReq',
    closedGraceTimeType: 'closedGraceTimeType',
    closedGraceTime: 'closedGraceTime',
    allowToReopenResolvedReq: 'allowToReopenResolvedReq',
    resolvedGraceTimeType: 'resolvedGraceTimeType',
    resolvedGraceTime: 'resolvedGraceTime',
    allowReqToAccessMyAsset: 'allowReqToAccessMyAsset',
    allowReqToAccessMyCi: 'allowReqToAccessMyCi',
    allowRequesterToViewBarcodeAndQRCode:
      'allowRequesterToViewBarcodeAndQRCode',
    allowRequesterToAccessKB: 'allowRequesterToAccessKB',
    allowRequesterToAccessServiceRequest:
      'allowRequesterToAccessServiceRequest',
    allowRequesterToAccessMyApprovals: 'allowRequesterToAccessMyApprovals',
    allowRequesterToAccessSolution: 'allowRequesterToAccessSolution',
    allowReqToAccessMyChanges: 'allowReqToAccessMyChanges',
    allowRequesterToCreateRequestBehalfOfOtherRequester:
      'allowRequesterToCreateRequestBehalfOfOtherRequester',
    allowRequesterToSubmitFeedback: 'allowRequesterToSubmitFeedback',
    allowRequesterToAccestTicketApprovalTab:
      'allowRequesterToAccestTicketApprovalTab',
    selfServiceSetting: 'selfServiceSetting',
    allowRequesterToCreateIncidents: 'allowRequesterToCreateIncidents',
    allowRequesterToCreateIncidentBehalfOfOtherRequester:
      'allowRequesterToCreateIncidentBehalfOfOtherRequester',
    allowRequesterToViewAuditTrail: 'allowRequesterToViewAuditTrail',
    mandateCommentToReopenRequest: 'mandateCommentToReopenRequest',
    allowRequestDueBy: 'allowRequestDueBy',
    requestAccessScopes: 'requestAccessScopes',
  }),
}

export const SupportPortalConfigMethods = mapActions({
  fetchConfigs: 'fetch',
})
